import { render, staticRenderFns } from "./ToggleTextAlign.vue?vue&type=template&id=c95d81ae&scoped=true&"
import script from "./ToggleTextAlign.vue?vue&type=script&lang=js&"
export * from "./ToggleTextAlign.vue?vue&type=script&lang=js&"
import style0 from "./ToggleTextAlign.vue?vue&type=style&index=0&id=c95d81ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c95d81ae",
  null
  
)

export default component.exports